export const initialValues = {
  full_name: '',
  company_name: '',
  website: '',
  email: '',
  phone: '',
  describe: '',
  text: '',
}
